/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO para la plantilla (roster), mostrando estadísticas agregadas de un jugador para un equipo en una temporada.
 */
export interface PlayerRosterStatsDTO { 
    player_id: string;
    player_name: string;
    total_matches_played: number;
    total_goals: number;
    total_exclusions: number;
    goals_per_match?: number;
}

